module.exports = __webpack_public_path__ + "static/media/birthed_logo.b957fa0d.png";